export enum InputNames {
  FIRST_NAME = 'firstname',
  LAST_NAME = 'lastname',
  EMAIL = 'email',
  MOBILE_PHONE = 'mobilephone',
  COMPANY = 'company',
  MESSAGE = 'message'
}
